module.exports = __webpack_public_path__ + "images/e847bb5a.img2-cht.png";


//////////////////
// WEBPACK FOOTER
// ./images/indexV2/img2-cht.png
// module id = 400
// module chunks = 0